import { Component, Vue } from "vue-property-decorator";
import * as Models from "../models";
import { resellerOrderCheckoutStore as store } from "../store";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import { EventBus } from "../../../events";

declare var google: any;

@Component
export default class ResellerMap extends Vue {
    public $refs!: {
        googleMap: any;
    };

    protected mapMarkerUrl: string = "/ui/img/site/marker.png";
    protected numberOfResellersToDisplay: number = 5;
    protected searchTerm: string = "";
    protected google: any = {};
    protected googleMapInit: boolean = false;
    protected currentPosition: Models.Position = {} as Models.Position;
    protected fallbackPosition: Models.Position = {
        lat: 56.39311481256241,
        lng: 12.731664035600776
    } as Models.Position;
    protected filteredResellers: Models.Reseller[] = [];

    constructor() {
        super();
    }

    protected mounted() {
        EventBus.$on("initMapSearch", (searchTerm: string) => {
            this.searchTerm = searchTerm;
            const checkExist = setInterval(() => {
                if (google !== undefined) {
                   this.findResellers();
                   clearInterval(checkExist);
                }
             }, 2000);
        });
    }

    protected created() {
        if (this.searchTerm === "") {
            this.setDefaultLocation();
        }
    }

    protected removeSelectedReseller() {
        this.selectedReseller = {} as Models.Reseller;
    }

    protected setDefaultLocation() {
        // Try get user location
        navigator.geolocation.getCurrentPosition(userPosition => {
            this.currentPosition.lat = userPosition.coords.latitude;
            this.currentPosition.lng = userPosition.coords.longitude;
            this.getClosestResellers(this.currentPosition);
        },
            error => {
                this.currentPosition = this.fallbackPosition;
                this.getClosestResellers(this.currentPosition);
            },
        );
    }

    protected boundsChanged(event: any) {
        if (this.googleMapInit) {
            return;
        }

        if (event) {
            this.googleMapInit = true;
            this.setFitBounds(this.currentPosition);
        }
    }

    protected handleInputDebounce(inputValue: any, event: Event) {
        if (HtmlElementHelper.isEventTargetFocusedElement(event.target)) {
            this.findResellers();
        }
    }

    protected findResellers() {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            address: this.searchTerm,
            componentRestrictions: {
                country: "SE",
            }
        }, (results: any, status: any) => {
            if (status === "OK") {
                if (results[0] && results[0].geometry) {
                    const position: Models.Position = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                    this.currentPosition = position;
                    this.getClosestResellers(position);
                }
            }
        });

    }

    protected handleSelectedResellerChange(reseller: Models.Reseller, event: Event) {
        if (event.target instanceof HTMLInputElement) {
            event.target.checked ? this.selectedReseller = reseller : this.removeSelectedReseller();
        }
    }

    protected getGooglePosition(reseller: Models.Reseller): Models.Position {
        return { lat: reseller.latitude, lng: reseller.longitude };
    }

    protected formatDistance(distance: number) {
        if (distance) {
            return distance.toFixed(1);
        }
    }

    private getClosestResellers(position: Models.Position) {
        this.calcFlyingDistance(position);
        this.setFitBounds(position);
    }

    private calcFlyingDistance(position: Models.Position) {
        const tempResellers = [...this.resellers];

        tempResellers.forEach((reseller, index) => {
            if (reseller.latitude !== 0 && reseller.longitude !== 0) {
                // ALTERNATIVE NO GOOGLE CALCULATION
                reseller.distance = this.getDistanceFromLatLonInMeters(position.lat, position.lng, reseller.latitude, reseller.longitude);
            }
        });

        tempResellers.sort((a, b) => {
            return a.distance - b.distance;
        }).splice(this.numberOfResellersToDisplay, this.resellers.length - this.numberOfResellersToDisplay);
        if (this.parseToBool(window.site.settings.enableresellerdefaultcheck) && tempResellers.length > 0) {
            tempResellers[0].default = true;
            this.selectedReseller = tempResellers[0];
        }

        this.filteredResellers = tempResellers;
    }

    private getDistanceFromLatLonInMeters(lat1: number, lon1: number, lat2: number, lon2: number) {
        const R = 6371; // Radius of the earth in km
        const dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        const dLon = this.deg2rad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // Distance in km
        return d;
    }

    private deg2rad(deg: number) {
        return deg * (Math.PI / 180);
    }

    private setFitBounds(position: Models.Position) {
        if (this.$refs.googleMap) {
            this.$refs.googleMap.$mapPromise.then((map: any) => {
                const bounds = new google.maps.LatLngBounds();
                if (this.filteredResellers.length > 0) {
                    this.filteredResellers.forEach((reseller: Models.Reseller) => {
                        bounds.extend(
                            new google.maps.LatLng(
                                reseller.latitude,
                                reseller.longitude
                            )
                        );
                    });
                    if (position) {
                        bounds.extend(
                            new google.maps.LatLng(
                                position.lat,
                                position.lng
                            )
                        );
                    }
                }

                window.innerWidth > 640 ? map.fitBounds(bounds, 100) : map.fitBounds(bounds);
                // Centers map correctly when overlay is used
                if (window.innerWidth > 640) {
                    const center = map.getCenter();  // a latLng
                    const offsetX = -0.205; // move center one quarter map width left
                    const offsetY = 0.00; // move center one quarter map height down
                    // NEED FIX - Init listen when map event bounds_changed
                    if (map.getBounds()) {
                        const span = map.getBounds().toSpan(); // a latLng - # of deg map spans
                        const newCenter = {
                            lat: center.lat() + span.lat() * offsetY,
                            lng: center.lng() + span.lng() * offsetX
                        };
                        map.panTo(newCenter);  // or map.setCenter(newCenter);
                    }
                }
            });
        }
    }
    private parseToBool(input: any) {
        if (input === "True") {
            return true;
        }
        return false;
    }

    get translations() {
        return store.translations;
    }

    get resellers() {
        return store.resellers;
    }

    get selectedReseller() {
        return store.selectedReseller;
    }


    set selectedReseller(reseller: Models.Reseller) {
        store.setSelectedReseller(reseller);
    }

    get mapOptions() {
        return Models.mapOptions;
    }
}
